import { apiPatch } from '../../../shared/api-client/index.js';

export type ApprovalStatus = 'pending' | 'approved' | 'rejected' | 'expired';
export type ApprovalKind = 'tool_call' | 'scenario_step' | 'contact_delete' | 'deal_delete';

export interface ApprovalItem {
  id: string;
  kind: ApprovalKind;
  status: ApprovalStatus;
  payload: Record<string, unknown>;
  expiresAt: string;
}

export interface DecideApprovalInput {
  approvalId: string;
  decision: 'approve' | 'reject';
}

export async function decideApproval(input: DecideApprovalInput): Promise<ApprovalItem> {
  return apiPatch<ApprovalItem, { decision: DecideApprovalInput['decision'] }>(`/approvals/${input.approvalId}`, {
    decision: input.decision,
  });
}
